import { useCalibration } from '../../../context/calibrationContext';
import { RulerReadoutView } from '../../session/calibration/ClinicianCalibrationViews';
import { useCalibrationSync } from '../../session/calibration/sync';

// Ruler calibration, clinician side: shows the width / height the patient typed (rulerDimensions
// -> optician-view runs rulerDimensionCalculations and sets `response`). Next = confirm.
const CalibrationRuler = ({ setStep, postMessage, response }) => {
  const { patchCalibration } = useCalibrationSync();
  const {
    updateCalibrationData,
    calibrationData: { rulerDimensions, pixelDensity },
  } = useCalibration();

  return (
    <RulerReadoutView
      widthMm={rulerDimensions?.widthMm}
      heightMm={rulerDimensions?.heightMm}
      received={Boolean(response)}
      onBack={() => {
        postMessage({ type: 'screen-calibration' });
        setStep('screen-calibration');
      }}
      onNext={() => {
        updateCalibrationData({ screenCalibrated: true });
        postMessage({ type: 'calibration-selection' });
        patchCalibration({ method: 'ruler', screen_calibrated: true, card_ratio: pixelDensity || null });
        return setStep('calibration-selection');
      }}
    />
  );
};

export default CalibrationRuler;
